import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
// import { hans } from './hans'
// import { hant } from './hant'
import hans from './hans.json'
import hant from './hant.json'
import hk from './hk.json'
import kr from './kr.json'
import en from './en.json'
import { setDefaultConfig } from 'antd-mobile'
import { antdLangMap } from '../utils/antdLangMap'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  'hans': { translation: hans },
  'hant': { translation: hant },
  'hk': { translation: hk },
  'kr': { translation: kr },
  'en': { translation: en },

  // en: {
  //   translation: {
  //     'Welcome to React': 'Welcome to React and react-i18next'
  //   }
  // },
  // fr: {
  //   translation: {
  //     'Welcome to React': 'Bienvenue à React et react-i18next'
  //   }
  // }
}

let defaultLanguage = 'hans'
const lang = process.env['REACT_APP_LANG']
if(lang) {
  defaultLanguage = lang
  // console.log(antdLangMap(lang))
  setDefaultConfig({locale: antdLangMap(lang)})
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: defaultLanguage, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
